<div class="flex min-h-screen items-center justify-center px-4 py-8">
  <div hlmCard class="w-full max-w-lg">
    <div hlmCardHeader class="items-center text-center">
      <app-logo [widthInPx]="140" class="mb-2" />
      <h1 hlmCardTitle>Willkommen bei Schenkwerk!</h1>
      <p hlmCardDescription>Dein Account wurde erfolgreich erstellt.</p>
    </div>

    <div hlmCardContent class="space-y-4">
      <div hlmAlert>
        <ng-icon name="lucideMail" />
        <p hlmAlertTitle>Bestätige deine E-Mail-Adresse</p>
        <p hlmAlertDescription>
          Wir haben dir eine Bestätigungs-E-Mail gesendet. Danach kannst du dich einloggen und dein
          Profil vervollständigen.
        </p>
      </div>

      @if (pendingGroupName) {
        <div hlmAlert>
          <ng-icon name="lucideUsers" />
          <p hlmAlertTitle>Einladung zu {{ pendingGroupName }}</p>
          <p hlmAlertDescription>
            Nach der E-Mail-Bestätigung kannst du dich einloggen und dem Netzwerk beitreten – dein
            Einladungslink bleibt aktiv.
          </p>
        </div>
      }

      <a
        hlmBtn
        class="w-full"
        [routerLink]="['/login']"
        [queryParams]="{ redirect: loginRedirect, groupName: pendingGroupName }">
        Jetzt einloggen
      </a>
    </div>

    <div hlmCardFooter class="justify-center">
      <p hlmMuted class="text-center text-xs">
        Keine E-Mail erhalten? Prüfe deinen Spam-Ordner oder kontaktiere unseren Support.
      </p>
    </div>
  </div>
</div>
